module.exports = __webpack_public_path__ + "img/CAN_TECATE.9700a604.png";